import { Model } from "@ofqual/portal-core/core/types";
import { Attachment } from "./Attachment";

type NullableString = string | null;

export enum AdditionalEvidenceRequestStatus {
  New = 0,
  InProgress = 1,
  Complete = 2
}

export type StatementsOfAssuranceRequestDeclarationOption = {
    id: string;
    optionText: string;
    hasRelatedDate: boolean;
    hasRelatedDescription: boolean;
    order: number;
}

export type StatementsOfAssuranceRequest = {
    id: string;
    relatedDescription?: string;
    relatedDate?: string;
    declaration: {
        id: string;
        name: string;
        title: string;
        introductionText: string;
        order: number;
        options: StatementsOfAssuranceRequestDeclarationOption[],
    }
    selectedDeclarationOption?: StatementsOfAssuranceRequestDeclarationOption;
    declarationOptionID: string;
}

export type AdditionalEvidenceRequest = {
  id: string,
  requestTitle: NullableString,
  dueDate: NullableString,
  introductionText: NullableString,
  statementsOfAssuranceStrs: string[],
  statementOfAssuranceRequests: StatementsOfAssuranceRequest[],
  isOtherEvidenceRequired: boolean,
  otherEvidenceText: NullableString,
  allowAttachments: boolean,
  status: AdditionalEvidenceRequestStatus,
  createdBy: string,
  createdDate: string,
  otherEvidenceResponseText?: string;
  attachments?: Attachment[];
  submittedBy?: string;
  submittedDate?: string;
  timestamp: string;
}

export const toApiModel = (request: AdditionalEvidenceRequest, statementLookups: any) => {
  const mappedStatements = request.statementsOfAssuranceStrs.map(id => {
    const statement = statementLookups.find((x: any) => x.id === id);
    return {
      id,
      name: statement ? statement.name : null,
    }
  });
  return {
    ...request,
    allowAttachments: request.allowAttachments || false,
    statementsOfAssurance: mappedStatements,
  } as Model;
};

export const mapStatementOfAssuranceToRequest = (newSao: StatementsOfAssuranceRequest, existingRequest: AdditionalEvidenceRequest) : AdditionalEvidenceRequest => {
  return {
    ...existingRequest,
    statementOfAssuranceRequests: existingRequest.statementOfAssuranceRequests.map(sao => sao.id === newSao.id ? newSao : sao)
  }
};

export const mapOtherEvidenceToRequest = (otherEvidenceResponseText: string, existingRequest: AdditionalEvidenceRequest) : AdditionalEvidenceRequest => {
  return {
    ...existingRequest,
    otherEvidenceResponseText,
  }
}